<template>
  <Modallogin v-if="showModallogin" @close="setUser"></Modallogin>
  <div v-else id="modal-signup">
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div
            class="modal-content"
            role="dialog"
            aria-labelledby="modalTitle"
            aria-describedby="modalDescription"
          >
            <button class="close-btn-modal" @click="$emit('close')" aria-label="Fermer"></button>
            <div class="modal-content-form">
              <div class="header-modal">
                <slot name="header">
                  <h1 class="merriweather-reg-26">Rejoindre le Club Hortense</h1>
                </slot>
                <div class="login">
                  <p class="raleway-reg-p15 mr-2" :class="isPhone() ? 'mb-0' : ''">Vous avez déjà un compte ?</p>
                  <a class="link-hortense" @click="showModallogin = true">Me connecter</a>
                </div>
              </div>
              <div class="form-signup raleway-reg-p15">
               <div class="form-item" :class="{ 'has-error': fieldErrors.last_name, 'has-success': fieldSuccess.last_name }">
                 <label for="last_name">Nom <span class="required">*</span></label>
                 <div class="input-wrapper">
                   <input id="last_name" ref="firstInput" v-model="userInfo.last_name" type="text" autocomplete="family-name" placeholder="Dupont" @blur="validateField('last_name')" />
                   <span class="field-icon success" v-if="fieldSuccess.last_name">✓</span>
                   <span class="field-icon error" v-else-if="fieldErrors.last_name">!</span>
                 </div>
                 <span class="field-error-msg" v-if="fieldErrors.last_name">{{ fieldErrors.last_name }}</span>
               </div>
                <div class="form-item" :class="{ 'has-error': fieldErrors.first_name, 'has-success': fieldSuccess.first_name }">
                  <label for="first_name">Prénom <span class="required">*</span></label>
                  <div class="input-wrapper">
                    <input id="first_name" v-model="userInfo.first_name" type="text" autocomplete="given-name" placeholder="Marie" @blur="validateField('first_name')" />
                    <span class="field-icon success" v-if="fieldSuccess.first_name">✓</span>
                    <span class="field-icon error" v-else-if="fieldErrors.first_name">!</span>
                  </div>
                  <span class="field-error-msg" v-if="fieldErrors.first_name">{{ fieldErrors.first_name }}</span>
                </div>
                <div class="form-item full-width">
                  <label for="birthday">Date de naissance</label>
                  <div class="input-wrapper">
                    <input id="birthday" v-model="userInfo.birthday" type="date" data-date-inline-picker="true" autocomplete="bday" />
                  </div>
                </div>
                <div class="form-item full-width" :class="{ 'has-error': fieldErrors.email, 'has-success': fieldSuccess.email }">
                  <label for="email">Email <span class="required">*</span></label>
                  <div class="input-wrapper">
                    <input id="email" v-model="userInfo.email" type="email" autocomplete="email" placeholder="marie@exemple.fr" @blur="validateField('email')" />
                    <span class="field-icon success" v-if="fieldSuccess.email">✓</span>
                    <span class="field-icon error" v-else-if="fieldErrors.email">!</span>
                  </div>
                  <span class="field-error-msg" v-if="fieldErrors.email">{{ fieldErrors.email }}</span>
                </div>

                <div class="form-item full-width" :class="{ 'has-error': fieldErrors.password, 'has-success': fieldSuccess.password }">
                  <label for="password">Mot de passe <span class="required">*</span> <span class="label-hint">(12 min.)</span></label>
                  <div class="input-wrapper">
                    <input id="password" v-model="userInfo.password" :type="showPassword ? 'text' : 'password'" autocomplete="new-password" placeholder="............" @blur="validateField('password')" />
                    <button type="button" class="toggle-password" @click="showPassword = !showPassword" :aria-label="showPassword ? 'Masquer' : 'Afficher'">
                      <span v-if="showPassword">&#128584;</span><span v-else>&#128065;</span>
                    </button>
                  </div>
                  <div class="password-strength" v-if="userInfo.password.length > 0">
                    <div class="strength-bar"><div class="strength-fill" :class="passwordStrengthClass" :style="{ width: passwordStrengthWidth }"></div></div>
                    <span class="strength-label" :class="passwordStrengthClass">{{ passwordStrengthLabel }}</span>
                  </div>
                  <span class="field-error-msg" v-if="fieldErrors.password">{{ fieldErrors.password }}</span>
                </div>
              </div>
              <div class="form-check raleway-p15">
                <div class="form-item newsletter">
                  <input
                    type="checkbox"
                    id="newsletter"
                    value="newsletter"
                    v-model="checkedItems"
                  />
                  <label for="newsletter"
                    >J’accepte de recevoir les newsletters d’Hortense et
                    j’accepte la
                    <a
                      :href="'/pages/privacy_policy/'"
                      class="link-hortense"
                      target="_blank"
                      >politique de confidentialité</a
                    >.</label
                  >
                </div>
                <!-- <div class="form-item privilege">
                  <input
                    type="checkbox"
                    id="privilege"
                    value="privilege"
                    v-model="checkedItems"
                  />
                  <label for="privilege" @click="createPrivilege"
                    >Je m’inscris au programme de fidélité</label
                  >
                </div> -->
                <!-- <div class="form-item charte">
                  <input
                    type="checkbox"
                    id="charte"
                    value="charte"
                    v-model="checkedItems"
                  />
                  <label for="charte"
                    >Je m’engage à respecter la
                    <a
                      :href="'/pages/ethic/'"
                      class="link-hortense"
                      target="_blank"
                      >charte d’engagements « Tourisme Durable »</a
                    ></label
                  >
                </div> -->
                <!-- <div class="form-item perso_info">
                  <input
                    type="checkbox"
                    id="perso_info"
                    value="perso_info"
                    v-model="checkedItems"
                  />
                  <label for="perso_info"
                    >J’accepte que mes informations soient utilisées, uniquement
                    dans le cadre de ma demande et dans le cadre de la relation
                    commerciale responsable, éthique et personnalisée qui peut
                    en découler.</label
                  >
                </div> -->
                <div v-if="text" class="form-error raleway-semi-p15" aria-live="polite"><span class="error-icon">⚠</span> {{ text }}</div>
                <button @click="UserBasicInfo" class="hortense-btn-primary" :disabled="isSubmitting">
                  {{ isSubmitting ? "Inscription en cours..." : "M'inscrire" }}
                </button>
              </div>
            </div>
            <div class="social-divider"><span>ou s'inscrire avec</span></div>
            <div class="social-connection-btn">
              <a href="/users/auth/google_oauth2" class="social-btn" @click="pushLoginEvent('google')">
                <img src="https://hortense-vue.s3.eu-west-3.amazonaws.com/static/google.png" alt="" aria-hidden="true" /> Google
              </a>
              <a href="/users/auth/facebook" class="social-btn" @click="pushLoginEvent('facebook')">
                <img src="https://hortense-vue.s3.eu-west-3.amazonaws.com/static/facebook.png" alt="" aria-hidden="true" /> Facebook
              </a>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import fetcher from "packs/shared/api.js";
import Modallogin from "./Modallogin.vue";

export default {
  name: "modal-signup",
  components: { Modallogin },
  props: { showModalLogin: Boolean },
  data() {
    return {
      userInfo: {
        first_name: "",
        last_name: "",
        birthday: "",
        email: "",
        password: "",
        newsletter: false,
      },
      checkedItems: [],
      showModal: false,
      showModallogin: this.showModalLogin,
      status: null,
      text: null,
      isSubmitting: false,
      showPassword: false,
      fieldErrors: { first_name: '', last_name: '', email: '', password: '' },
      fieldSuccess: { first_name: false, last_name: false, email: false, password: false },
    };
  },
  computed: {
    passwordStrengthClass() {
      const len = this.userInfo.password.length;
      if (len < 8) return 'weak';
      if (len < 12) return 'fair';
      const hasUpper = /[A-Z]/.test(this.userInfo.password);
      const hasNum = /[0-9]/.test(this.userInfo.password);
      const hasSpecial = /[^A-Za-z0-9]/.test(this.userInfo.password);
      if (hasUpper && hasNum && hasSpecial) return 'strong';
      return 'good';
    },
    passwordStrengthWidth() {
      return { weak: '25%', fair: '50%', good: '75%', strong: '100%' }[this.passwordStrengthClass];
    },
    passwordStrengthLabel() {
      return { weak: 'Faible', fair: 'Passable', good: 'Bon', strong: 'Fort' }[this.passwordStrengthClass];
    },
  },
  beforeDestroy() {
    const whatsappBtn = document.getElementById('whatsapp-button');
    if (whatsappBtn) {
      whatsappBtn.style.display = 'block';
    }
    document.querySelectorAll('.fixed-banner').forEach(el => {
      el.style.zIndex = '';
    });
    document.querySelectorAll('.fixed-bannertwo').forEach(el => {
      el.style.zIndex = '';
    });
    
    // Re-enable body scroll on mobile
    if (this.isPhone()) {
      document.body.style.overflow = '';
    }
  },
  mounted() {
    const whatsappBtn = document.getElementById('whatsapp-button');
    if (whatsappBtn) {
      whatsappBtn.style.display = 'none';
    }
    document.querySelectorAll('.fixed-banner').forEach(el => {
      el.style.zIndex = '1';
    });
    document.querySelectorAll('.fixed-bannertwo').forEach(el => {
      el.style.zIndex = '1';
    });
    
    // Focus on first input field
    this.$nextTick(() => {
      if (this.$refs.firstInput) {
        this.$refs.firstInput.focus();
      }
    });
    
    // Block body scroll on mobile
    if (this.isPhone()) {
      document.body.style.overflow = 'hidden';
    }
  },
  methods: {
    validateField(field) {
      this.fieldErrors[field] = '';
      this.fieldSuccess[field] = false;
      const val = (this.userInfo[field] || '').trim();
      if (field === 'email') {
        if (!val) { this.fieldErrors.email = 'Email requis'; return; }
        if (!this.validateEmail(val)) { this.fieldErrors.email = 'Format invalide'; return; }
        this.fieldSuccess.email = true;
      } else if (field === 'password') {
        if (val.length < 12) { this.fieldErrors.password = '12 caractères minimum'; return; }
        this.fieldSuccess.password = true;
      } else {
        if (!val) { this.fieldErrors[field] = 'Champ requis'; return; }
        this.fieldSuccess[field] = true;
      }
    },
    isPhone() {
      return window.innerWidth <= 480;
    },
    pushLoginEvent(method) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'sign_up',
        method: method,
      });
    },
    formatDate(date) {
      if (!date) {
        return "";
      }
      const set = new Date(date);
      let getDate = set.getDate().toString();
      if (getDate.length === 1) {
        getDate = "0" + getDate;
      }
      let getMonth = (set.getMonth() + 1).toString();
      if (getMonth.length === 1) {
        getMonth = "0" + getMonth;
      }
      let getYear = set.getFullYear().toString();
      //today
      return getYear + "-" + getMonth + "-" + getDate;
    },
    validateEmail(email) {
      return String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    },
    async UserBasicInfo() {
      if (this.isSubmitting) {
        return;
      }

      this.text = null;

      if (!this.validateEmail(this.userInfo.email)) {
        this.text = "Email incorrect";
        return;
      }
      if (this.userInfo.password.length < 12) {
        this.text = "Le mot de passe doit contenir 12 caractères minimum ";
        return;
      }

      this.userInfo.newsletter = this.checkedItems.includes("newsletter");

      this.isSubmitting = true;

      try {
        const response = await fetcher.post("/users/", {
          user: {
            first_name: this.userInfo.first_name,
            last_name: this.userInfo.last_name,
            birthday: this.formatDate(this.userInfo.birthday),
            email: this.userInfo.email,
            password: this.userInfo.password,
            password_confirmation: this.userInfo.password,
            newsletter: this.userInfo.newsletter,
          },
        });
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'sign_up',
          method: 'email_password',
        });
        if (!response.error){

          //window.location.replace(this.redirectUrl)
          // Turbolinks.visit('dashboard/' + response.data.id);
          this.$emit("close", response.data);
          location.reload();
        }
      } catch (e) {
        console.log(e);
        
        // Check if there's a response with error details
        if (e.response && e.response.data) {
          // Handle different types of error responses
          if (e.response.data.errors) {
            // If errors is an object with field-specific errors
            if (typeof e.response.data.errors === 'object') {
              const errorMessages = [];
              for (const [field, messages] of Object.entries(e.response.data.errors)) {
                if (Array.isArray(messages)) {
                  errorMessages.push(...messages.map(msg => this.translateErrorMessage(field, msg)));
                } else {
                  errorMessages.push(this.translateErrorMessage(field, messages));
                }
              }
              this.text = errorMessages[0];
            } else if (Array.isArray(e.response.data.errors)) {
              // If errors is an array
              this.text = e.response.data.errors.map(msg => this.translateErrorMessage('', msg))[0];
            } else {
              // If errors is a string
              this.text = this.translateErrorMessage('', e.response.data.errors);
            }
          } else if (e.response.data.error) {
            // Single error message
            this.text = this.translateErrorMessage('', e.response.data.error);
          } else if (e.response.data.message) {
            // Message field
            this.text = this.translateErrorMessage('', e.response.data.message);
          } else {
            // Fallback to status-based messages
            switch (e.response.status) {
              case 422:
                this.text = "Les données saisies ne sont pas valides";
                break;
              case 409:
                this.text = "Cet email est déjà utilisé";
                break;
              case 500:
                this.text = "Erreur serveur, veuillez réessayer plus tard";
                break;
              default:
                this.text = "Une erreur est survenue lors de l'inscription";
            }
          }
        } else {
          this.text = "Impossible de terminer l'inscription. Vérifiez que vos informations sont correctes et réessayez.";
        }
      } finally {
        this.isSubmitting = false;
      }
    },
    translateErrorMessage(field, message) {
      // Translation map for common error messages
      const translations = {
        'has already been taken': 'est déjà utilisé',
        'is too short': 'est trop court',
        'is too long': 'est trop long',
        'is invalid': 'est invalide',
        'can\'t be blank': 'ne peut pas être vide',
        'doesn\'t match': 'ne correspond pas',
        'must be accepted': 'doit être accepté',
        'is not included in the list': 'n\'est pas inclus dans la liste',
        'must be greater than': 'doit être supérieur à',
        'must be less than': 'doit être inférieur à',
        'must be equal to': 'doit être égal à',
        'must be confirmed': 'doit être confirmé',
        'is not a number': 'n\'est pas un nombre',
        'is reserved': 'est réservé'
      };

      // Field name translations
      const fieldTranslations = {
        'email': 'L\'email',
        'password': 'Le mot de passe',
        'password_confirmation': 'La confirmation du mot de passe',
        'first_name': 'Le prénom',
        'last_name': 'Le nom',
        'birthday': 'La date de naissance'
      };

      // Get translated message
      let translatedMessage = message;
      for (const [english, french] of Object.entries(translations)) {
        if (message.includes(english)) {
          translatedMessage = message.replace(english, french);
          break;
        }
      }

      // Add field name if available
      if (field && fieldTranslations[field]) {
        return `${fieldTranslations[field]} ${translatedMessage}`;
      }

      return translatedMessage;
    },
    async createPrivilege() {
      try {
        const response = await fetcher.post("/privileges");
      } catch (e) {
        console.error(e);
      }
    },
    setUser(user) {
      this.user = user;

      if (user) {
        this.$emit("close", user);
        return;
      }

      this.showModal = false;
      this.showModallogin = false;
      this.$emit("close", user);
    },
  },
};
</script>

<style lang="scss" scoped>
// ── Close button ──────────────────────────────────────────────
.close-btn-modal {
  position: absolute;
  top: 1rem;
  right: 1.25rem;
  background: none;
  border: none;
  font-size: 1.75rem;
  line-height: 1;
  color: #555;
  cursor: pointer;
  z-index: 10;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  transition: color 0.2s, background 0.2s;

  &:hover { color: #3B6152; background: rgba(59,97,82,0.08); }
}

// ── Modal layout ──────────────────────────────────────────────
.modal-mask {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001 !important;
  overflow-y: auto;
}

.modal-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.modal-content {
  position: relative;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 40px rgba(0,0,0,0.18);
  width: 100%;
  max-width: 680px;
  overflow: hidden;
  animation: modalIn 0.25s ease;

  @media (max-width: 768px) {
    max-width: 100%;
    border-radius: 0;
    min-height: 100vh;
  }
}

@keyframes modalIn {
  from { opacity: 0; transform: translateY(16px); }
  to   { opacity: 1; transform: translateY(0); }
}

// ── Form panel ────────────────────────────────────────────────
.modal-content-form {
  padding: 3rem 3.5rem 1.5rem;
  overflow-y: auto;
  max-height: 90vh;

  @media (max-width: 768px) {
    padding: 2.5rem 1.25rem 1.25rem;
    max-height: none;
  }
}

// ── Header ────────────────────────────────────────────────────
.header-modal {
  margin-bottom: 1.25rem;

  h1 { margin: 0 0 0.2rem; }

  .signup-subtitle {
    color: #6c757d;
    margin: 0 0 0.75rem;
  }

  .login {
    display: flex;
    align-items: center;
    gap: 0.35rem;
    flex-wrap: wrap;

    p { margin: 0; color: #555; }
  }
}

// ── Form grid ─────────────────────────────────────────────────
.form-signup {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem 1rem;
  margin-bottom: 1rem;

  .form-item.full-width { grid-column: 1 / -1; }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 0.65rem;
  }
}

// ── Form items ────────────────────────────────────────────────
.form-item {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;

  label {
    font-size: 0.82rem;
    font-weight: 600;
    color: #333;
    letter-spacing: 0.01em;
    @media (max-width: 768px) {
      margin-bottom: 0;
    }
  }

  .required { color: #c0392b; }

  .label-hint {
    font-weight: 400;
    color: #888;
    font-size: 0.78rem;
  }

  // Input wrapper for icon positioning
  .input-wrapper {
    position: relative;
    display: flex;
    align-items: center;

    input {
      width: 100%;
      padding: 0.65rem 2.5rem 0.65rem 0.85rem;
      border: 1.5px solid #d0d0d0;
      border-radius: 6px;
      font-size: 0.9rem;
      font-family: inherit;
      background: #fafafa;
      transition: border-color 0.2s, box-shadow 0.2s;
      box-sizing: border-box;

      &:focus {
        outline: none;
        border-color: #3B6152;
        background: #fff;
        box-shadow: 0 0 0 3px rgba(59,97,82,0.12);
      }

      &::placeholder { color: #bbb; font-size: 0.85rem; }
    }
  }

  // Validation state borders
  &.has-error .input-wrapper input {
    border-color: #e74c3c;
    background: #fff8f8;
  }
  &.has-success .input-wrapper input {
    border-color: #27ae60;
    background: #f6fff9;
  }

  .field-icon {
    position: absolute;
    right: 0.75rem;
    font-size: 0.85rem;
    font-weight: 700;
    pointer-events: none;

    &.success { color: #27ae60; }
    &.error   { color: #e74c3c; }
  }

  .field-error-msg {
    font-size: 0.75rem;
    color: #e74c3c;
    margin-top: 0.1rem;
  }

  // Newsletter checkbox row
  &.newsletter {
    flex-direction: row;
    align-items: flex-start;
    gap: 0.6rem;

    input[type="checkbox"] { margin-top: 3px; flex-shrink: 0; }

    label {
      font-weight: 400;
      color: #444;
      font-size: 0.82rem;
      line-height: 1.5;
    }
  }
}

// Toggle password button
.toggle-password {
  position: absolute;
  right: 0.6rem;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  font-size: 1rem;
  line-height: 1;
  opacity: 0.6;
  transition: opacity 0.2s;
  &:hover { opacity: 1; }
}

// Password strength
.password-strength {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.25rem;

  .strength-bar {
    flex: 1;
    height: 4px;
    background: #e9ecef;
    border-radius: 4px;
    overflow: hidden;

    .strength-fill {
      height: 100%;
      border-radius: 4px;
      transition: width 0.3s ease, background 0.3s ease;

      &.weak   { background: #e74c3c; }
      &.fair   { background: #f39c12; }
      &.good   { background: #3498db; }
      &.strong { background: #27ae60; }
    }
  }

  .strength-label {
    font-size: 0.72rem;
    font-weight: 600;
    width: 3.5rem;
    text-align: right;

    &.weak   { color: #e74c3c; }
    &.fair   { color: #f39c12; }
    &.good   { color: #3498db; }
    &.strong { color: #27ae60; }
  }
}

// ── Form check (newsletter + button) ─────────────────────────
.form-check {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  padding-top: 0.25rem;

  @media screen and (max-width: 480px) {
    padding-top: 0;
  }
}

.form-error {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  color: #e74c3c;
  font-size: 0.82rem;
  background: #fff3f3;
  border: 1px solid #ffd0d0;
  border-radius: 6px;
  padding: 0.45rem 0.75rem;
  width: 100%;

  .error-icon { font-size: 0.9rem; }
}

// ── Primary button ────────────────────────────────────────────
button.hortense-btn-primary {
  width: 100%;
  max-width: 320px;
  height: 52px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  border: 0;
  font-weight: 700;
  font-size: 13px;
  letter-spacing: 0.04em;
  transition: opacity 0.2s, transform 0.15s;

  &:hover:not([disabled]) { transform: translateY(-1px); }
  &[disabled] { opacity: 0.6; cursor: not-allowed; }
}

// ── Social sign-in ────────────────────────────────────────────
.social-divider {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 0 0.5rem;
  color: #aaa;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;

  &::before, &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: #e9ecef;
  }
}

.social-connection-btn {
  display: flex;
  justify-content: center;
  gap: 0.75rem;
  padding-bottom: 1.5rem;

  .social-btn {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex: 1;
    max-width: 180px;
    justify-content: center;
    border: 1.5px solid #e0e0e0;
    border-radius: 8px;
    padding: 0.6rem 1rem;
    text-decoration: none;
    color: #444;
    font-size: 0.88rem;
    font-weight: 500;
    transition: border-color 0.2s, box-shadow 0.2s, transform 0.15s;
    cursor: pointer;

    img {
      width: 20px;
      height: 20px;
      object-fit: contain;
      flex-shrink: 0;
    }

    &:hover {
      border-color: #3B6152;
      box-shadow: 0 2px 8px rgba(59,97,82,0.12);
      transform: translateY(-1px);
      color: #3B6152;
    }
  }
}

// ── Link ──────────────────────────────────────────────────────
.link-hortense {
  color: #3B6152;
  cursor: pointer;
  font-weight: 600;
  transition: color 0.2s;
  text-decoration: none;

  &:hover { color: #2d4a3d; text-decoration: underline; }
}

// ── Transition ────────────────────────────────────────────────
.modal-enter-active, .modal-leave-active { transition: opacity 0.25s ease; }
.modal-enter, .modal-leave-to { opacity: 0; }
</style>
